import { userRole, checkAvailabilityRole } from 'helpers/user';

export default {
  checkAuthAndRole(to, from, next) {
    const role = userRole();
    const roles = to.meta.roles;

    if (!role) return next({ name: 'login' });

    if (roles && checkAvailabilityRole(role, roles)) {
      next();
    } else {
      next({ name: 'access-denied' });
    }
  }
};
